module.exports = __webpack_public_path__ + "static/media/ehealth_pro_noti_tips_step_2.1bffac15.png";